import type { Site } from '../Site';

export const ComputerActive: Site = {
  id: 'getcomputeractive',
  analyticsName: 'getcomputeractive',
  selector: '',
  logo: '',
  label: 'Computer Active',
  platform: '',
};
